module.exports = __webpack_public_path__ + "static/media/disabledExcel.db1436f2.svg";